import type {
  Configuration,
  CreateIdpGroupRequest,
  UpdateIdpGroupRequest,
} from '@repo/api-gw-sdk';
import { IamApi } from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

const baseUrl = '/idpGroups';

export const idpGroups = (httpClient: HttpClient, config: Configuration) => {
  const iamApi = new IamApi(config);

  return {
    useList: () =>
      httpClient.execute(iamApi.listIdpGroups.bind(iamApi), baseUrl, ''),
    create: (input: CreateIdpGroupRequest) => iamApi.createIdpGroup(input),
    update: (groupId: string, input: UpdateIdpGroupRequest) =>
      iamApi.updateIdpGroup(groupId, input),
    delete: (groupId: string) => iamApi.deleteIdpGroup(groupId),
  };
};
